import script from "./CommandList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandList.vue?vue&type=script&setup=true&lang=js"

import "./CommandList.vue?vue&type=style&index=0&id=39f74ef9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f74ef9"]])

export default __exports__